import React, { Component } from 'react';

class CheckboxTeacher extends Component {
    state = {
        isChecked: false,
    }

    componentDidUpdate(prevProps) {
        if (prevProps.id_teacher !== this.props.id_teacher) {
            this.setState({ isChecked: false })
        }
    }

    toggleCheckboxChangeTeacher = () => {
        const { handleCheckboxChangeTeacher, okno_pole } = this.props;

        this.setState(({ isChecked }) => (
            {
                isChecked: !isChecked,
            }
        ));
        handleCheckboxChangeTeacher(okno_pole);
        this.props.ChekedControl()
    }

    render() {
        const { okno_pole, title, dolg, visibles, visibility } = this.props;
        const { isChecked } = this.state;

        return (
            <div className="checkbox">
                {visibility === true ?
                    visibles === true ?
                        <label>
                            <input
                                type="checkbox"
                                value={okno_pole}
                                checked={dolg === true ? !isChecked : isChecked}
                                onChange={this.toggleCheckboxChangeTeacher}
                            />
                            <p>{title}</p>
                        </label>
                        : <label className="access_false" >
                            {dolg === true ?
                                <label className="TrueTrue"
                                /> :
                                <label className="NoneNone"
                                />}
                            <p className='pole_title_acces_false'>{title}</p>
                        </label> : null}
            </div>
        );
    }
}

export default CheckboxTeacher;